import { render, staticRenderFns } from "./terminos-condiciones.vue?vue&type=template&id=5f2f4363&"
import script from "./terminos-condiciones.vue?vue&type=script&lang=js&"
export * from "./terminos-condiciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports